<template>
  <v-dialog v-model="modalActivo" persistent max-width="480">
    <v-form ref="form1">
      <v-container grid-list-sm text-center>
        <v-card :color="$store.state.sysBackgroundColor">
          <v-card-title>
            <v-layout row wrap>
              <v-flex>
                <h3 class="overline">{{ titulo }}</h3>
                <p class="caption font-weight-light">{{ comprobante }}</p>
              </v-flex>
            </v-layout>
          </v-card-title>
          <v-card-text>
            <v-layout row wrap>
              <v-flex>
                <SelectBanco
                  :model="itemActivo.Id_Banco"
                  :rules="[rules.requerido]"
                  @seleccionarItem="seleccionarBanco"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 md6>
                <v-text-field
                  ref="controlFocoNumero"
                  label="Nº*"
                  v-model="itemActivo.NumeroChequeTercero"
                  v-mask="'########'"
                  :rules="[rules.requerido]"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md6>
                <Fecha
                  label="Pago*"
                  :fecha="itemActivo.FechaPago"
                  :rules="[rules.requerido]"
                  :sinFechaMaxima="true"
                  @seleccionarItem="item => (itemActivo.FechaPago = item.Fecha)"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex>
                <v-text-field
                  label="Titular*"
                  v-model="itemActivo.Titular"
                  :rules="[rules.requerido]"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs6 offset-xs6 md4 offset-md8>
                <Importe2
                  refocus="controlFocoImporte"
                  label="Importe*"
                  v-model="itemActivo.Importe"
                  :rules="[rules.requerido]"
                  @seleccionarItem="seleccionarImporte"
                />
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn text small @click="ejecutarAccion('Cerrar')">
              Cancelar
              <v-icon right>clear</v-icon>
            </v-btn>
            <v-btn color="primary" small @click="ejecutarAccion('Aceptar')">
              Aceptar
              <v-icon right>check</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-container>
    </v-form>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/main";
import SelectBanco from "@/components/Banco/SelectBanco";
import Fecha from "@/components/Fecha";
import Importe2 from "@/components/Importe2";
export default {
  name: "ModalTipoPagoCheque",
  components: {
    SelectBanco,
    Fecha,
    Importe2
  },
  props: {
    activo: Boolean,
    comprobante: String,
    importe: Number,
    titular: String
  },
  data() {
    return {
      titulo: "Pago con Cheque",
      itemVacio: {
        Id_Banco: 0,
        NumeroChequeTercero: "",
        FechaPago: "",
        Titular: "",
        Importe: 0
      },
      itemActivo: {},
      modalActivo: false,
      rules: {
        requerido: v => !!v || "Requerido"
      }
    };
  },
  watch: {
    activo() {
      this.modalActivo = this.activo;
      if (this.modalActivo) {
        this.itemActivo.Importe = this.importe;
        this.itemActivo.Titular = this.titular;
        setTimeout(() => {
          eventBus.$emit("setearFocoSelectBanco");
        }, 100);
      } else this.inicializar();
    }
  },
  created() {
    this.inicializar();
  },
  methods: {
    inicializar() {
      this.itemActivo = Object.assign({}, this.itemVacio);
    },
    seleccionarBanco(item) {
      this.itemActivo.Id_Banco = item.Id_Banco;
      this.$refs.controlFocoNumero.focus();
    },
    seleccionarImporte() {
      this.ejecutarAccion("Aceptar");
    },
    ejecutarAccion(accion) {
      if (accion == "Aceptar") {
        if (this.$refs.form1.validate())
          this.$emit("ejecutarAccion", accion, this.itemActivo);
      } else this.$emit("ejecutarAccion", accion, null);
    }
  }
};
</script>
